<div>
  <app-stored-file-finder-list></app-stored-file-finder-list>
</div>
